import debounce from 'lodash/debounce';
import toArray from '../helpers/toArray';

const SearchableScrollbox = {
  /**
   * Create count element
   * @param {HTMLElement} node
   * @param {Object} props
   * @return {Void}
   */
  create(node/* , props */) {
    // Search field for the scrollbox
    const searchField = node.querySelector('.js-scrollbox-search');

    // Get all items in the scrollbox
    this.items = toArray(node.querySelectorAll('[data-label]'));

    // Add a small debounce to prevent too many keypresses
    const debouncedFilter = debounce(this.filter.bind(this), 100);

    // Run the filter on page load
    this.filter(searchField.value);

    searchField.addEventListener('keyup', () => {
      debouncedFilter(searchField.value);
    });
  },

  /**
   * Really simple normalizer
   * @param {String} str
   * @return {String}
   */
  normalizeSearch(str) {
    return str.toLowerCase().trim();
  },

  /**
   * Filter items by the given search string
   * @param {String} search
   * @return {Void}
   */
  filter(search) {
    const normalizedSearch = this.normalizeSearch(search);

    this.items.forEach((item) => {
      // Get the label of the item
      const label = this.normalizeSearch(item.dataset.label);

      // Check if the item should be visible
      const isVisible = label.indexOf(normalizedSearch) >= 0;

      // Show/hide item
      item.style.display = (isVisible) ? 'block' : 'none';
    });
  },
};

export default SearchableScrollbox;
